import { addDays, compareAsc } from 'date-fns';
import { atom } from 'jotai';

import { toIsoDate } from '@service-initiation/shared-utils-date-time';
import {
  getOpenAppointments,
  getRemoteTechEligibilityAndOptions,
} from '@service-initiation/tech-care-data-access-tech-care-services';

import { DeliveryMethod } from '../types';
import { convertRemoteTechAvailableWindowsToTimeSlots } from '../utils';
import { deliveryMethodAsyncAtom } from './deliveryMethodAsyncAtom';
import { remoteTechAtom } from './remoteTechAtom';
import { selectedRepairsAsyncAtom } from './selectedRepairsAsyncAtom';
import { selectedStoreAsyncAtom } from './selectedStoreAsyncAtom';

export const availableAppointmentDatesAsyncAtom = atom(async (get) => {
  const startDate = toIsoDate(new Date());
  const selectedStore = await get(selectedStoreAsyncAtom);
  const deliveryMethod = await get(deliveryMethodAsyncAtom);
  const selectedRepairs = await get(selectedRepairsAsyncAtom);
  const storeId = selectedStore?.id;
  const remoteTech = get(remoteTechAtom);

  if (deliveryMethod === DeliveryMethod.ComeToMe) {
    const remoteTechEligibility = selectedRepairs
      ? await getRemoteTechEligibilityAndOptions({
          deviceRepairId: selectedRepairs?.[0].id,
          postal_code: remoteTech?.meetingAddress?.zip ?? '',
        })
      : undefined;
    const weekFromTodayDate = addDays(new Date(), 7);

    const convertedTimeSlots = convertRemoteTechAvailableWindowsToTimeSlots(
      remoteTechEligibility?.options?.available_windows ?? []
    );
    const filteredTimeSlots = convertedTimeSlots.filter(
      (timeSlot) => compareAsc(new Date(timeSlot.date), weekFromTodayDate) <= 0
    );

    return filteredTimeSlots;
  } else {
    if (!storeId) {
      return [];
    }
    const appointments = await getOpenAppointments({
      startDate,
      storeId,
    });

    return appointments;
  }
});
